// extracted by mini-css-extract-plugin
export default {"button":"UpButton_button__PUSMs","flareAnimation":"UpButton_flareAnimation__0C-88","shine":"UpButton_shine__A5tZi"};